import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { PayActionContext } from "./PayActionContext";

function useStore() {
  const { element, setBackendFormErrors } = useContext(
    PayActionContext
  );
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    store("categories/enrollment/pay", element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useStore;
